import { Box } from "@mui/material";
import React from "react";
import { ChangePasswordBox } from "../Components";
import { useLocation } from "react-router-dom";

export default function Profile() {
  const location = useLocation();
  const profilEmail = location.state?.profilEmail;
  return (
    <Box>
      {/* <ChangePasswordBox patientName={userName} email={userName} /> */}
      <ChangePasswordBox email={profilEmail} />
    </Box>
  );
}
